import React, { ReactNode, createContext, useContext, useState } from 'react';

interface OffertaModalContextProps {
	showModal: boolean;
	setShowModal: (value: boolean) => void;
	entryUrl: string;
	categoryId: string;
	offertaEnquiryCreateFormScriptUrl: string;
}

const OffertaModalContext = createContext<OffertaModalContextProps>({
	showModal: false,
	setShowModal: () => {},
	entryUrl: '',
	categoryId: '',
	offertaEnquiryCreateFormScriptUrl: '',
});

export const useOffertaModal = (): OffertaModalContextProps => useContext(OffertaModalContext);

export const OffertaModalProvider: React.FC<{
	value: { entryUrl: string; categoryId: string; offertaEnquiryCreateFormScriptUrl: string };
	children: ReactNode;
}> = ({ value, children }) => {
	const [showModal, setShowModal] = useState(false);

	return (
		<OffertaModalContext.Provider
			value={{
				showModal,
				setShowModal,
				entryUrl: value.entryUrl,
				categoryId: value.categoryId,
				offertaEnquiryCreateFormScriptUrl: value.offertaEnquiryCreateFormScriptUrl,
			}}
		>
			{children}
		</OffertaModalContext.Provider>
	);
};
